import { useLazyQuery, useQuery } from "@apollo/client";
import { useState, createContext, useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Get_file_dashboard, GET_FLAGGED_MSG, FLAGGED_TASKS, Get_notifications_dashboard, GET_STAR_FILES, TOTAL_FLAGGED_ITEMS } from "../apollo/Queries";
import { categorizeTasks } from "../Utils/taskHelper";
// import { decodeTitleOnly } from "../Utils/Common";
import { set_dashboardNotification } from "../redux/dashboardSlice";
import { modifyMyMsg, scrollToBottom } from "../Utils/Common";
import { set_messages, setPopup } from "../redux/messageSlice";
import { useLocation } from "react-router-dom";

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const { user, total_unread, conversations, active_conversation, change_file_data } = useSelector(state => state.message);
    const { dashboardNotification } = useSelector(state => state.dashboard);
    const [files, setFiles] = useState([]);
    const [tasks] = useState([]);
    // flagged should be an object with a `flagged` array and `pagination` to match API usage
    const [flagged, setFlagged] = useState({ flagged: [], pagination: null });
    const [notifications, setNotifications] = useState([]);
    const [loader, setLoader] = useState(true);
    // completion flags for each API so we can hide the loader when all are done
    // const [filterDone, setFilterDone] = useState(false);
    // const [tasksDone, setTasksDone] = useState(false);
    const [notificationsDone, setNotificationsDone] = useState(false);
    const [filesDone, setFilesDone] = useState(false);
    const [prevloader, setPrevLoader] = useState(false);
    const [fileViewPopup, setFileViewPopup] = useState(false);
    const [totalFlaggedItems, setTotalFlaggedItems] = useState(null);
    const [activeRoomId, setActiveRoomId] = useState('');
    const [flagTab, setFlagTab] = useState('messages');
    const [pagination, setPagination] = useState({ page: 1, totalPages: 1, total: 0 });
    const [flagAndFileLoader, setFlagAndFileLoader] = useState(true);
    const [isFavoriteFileOpen, setIsFavoriteFileOpen] = useState(false);
    const [isFlaggedOpen, setIsFlaggedOpen] = useState(false);
    const [favoriteFiles, setFavoriteFiles] = useState([]);
    const [flaggedTasks, setFlaggedTasks] = useState([]);
    const msgContainerRef = useRef(null);
    const prevScrollHeightMsg = useRef(0);

    useQuery(TOTAL_FLAGGED_ITEMS, {
        fetchPolicy: 'no-cache', onCompleted: (data) => {
            console.log("🚀 ~ DashboardProvider ~ TOTAL_FLAGGED_ITEMS:", data)
            setTotalFlaggedItems(data.total_flagged_items);
        }
    })

    const [getFlaggedMsg] = useLazyQuery(GET_FLAGGED_MSG, {
        fetchPolicy: 'no-cache',
        onCompleted: async (data) => {
            console.log("🚀 ~ DashboardProvider ~ GET_FLAGGED_MSG:", data);
            const res_msgs = await modifyMyMsg(data.get_flagged_msg.msgs);
            dispatch(setPopup({ key: 'chat_loader', value: false }))
            setPagination(data.get_flagged_msg.pagination);

            if (data.get_flagged_msg.pagination.page === 1) {
                dispatch(set_messages({ data: res_msgs, is_reply_msg: "no", page: 1 }));
                setTimeout(() => {
                    scrollToBottom("main_msg_scroll_div");
                }, 300);
            } else {
                dispatch(set_messages({ data: res_msgs, is_reply_msg: "no", page: data.get_flagged_msg.pagination.page }));
                requestAnimationFrame(() => {
                    msgContainerRef.current.scrollTop = msgContainerRef.current?.scrollHeight - prevScrollHeightMsg?.current;
                });
            }

            setFlagAndFileLoader(false);
            setPrevLoader(false);
            setLoader(false);
        },
        onError: (err) => {
            console.error('GET_FLAGGED_MSG error', err);
            setFlagAndFileLoader(false);
            setPrevLoader(false);
            setLoader(false);
        },
    });

    const [getFlaggedTask] = useLazyQuery(FLAGGED_TASKS, {
        fetchPolicy: 'no-cache',
        onCompleted: async (data) => {
            console.log("🚀 ~ DashboardProvider ~ FLAGGED_TASKS:", data.flagged_tasks.data);
            setFlaggedTasks(data.flagged_tasks.data);
            setPagination(data.flagged_tasks.pagination);
            setFlagAndFileLoader(false);
            setPrevLoader(false);
            setLoader(false);
        },
        onError: (err) => {
            console.error('GET_FLAGGED_MSG error', err);
            setFlagAndFileLoader(false);
            setPrevLoader(false);
            setLoader(false);
        },
    });

    const [getStarFiles] = useLazyQuery(GET_STAR_FILES, {
        fetchPolicy: 'no-cache',
        onCompleted: async (data) => {
            console.log("🚀 ~ DashboardProvider ~ GET_STAR_FILES:", data.get_star_file);

            if (data.get_star_file.pagination.page === 1) {
                setFavoriteFiles(data.get_star_file.files)
            } else {
                setFavoriteFiles(prev => [...prev, ...data.get_star_file.files])
            }
            setPagination(data.get_star_file.pagination);

            setFlagAndFileLoader(false);
            setPrevLoader(false);
            setLoader(false);
        },
        onError: (err) => {
            console.error('GET_FLAGGED_MSG error', err);
            setPrevLoader(false);
            setFlagAndFileLoader(false);
            setLoader(false);
        },
    });


    useEffect(() => {
        if (change_file_data) {
            console.log('change_file_data:', change_file_data);
            if (change_file_data.xmpp_type === 'star_file') {
                // setFavoriteFiles(prev => prev.map(f => f.id === change_file_data.file_id ? { ...f, star: change_file_data.star } : f))
                setFavoriteFiles(prev => prev.filter(f => f.id !== change_file_data.file_id))
            } else if (change_file_data.xmpp_type === 'delete_msg' || change_file_data.xmpp_type === 'delete_one_file') {
                setFavoriteFiles(prev => prev.filter(f => f.id !== change_file_data.file_id))
            } else if (change_file_data.xmpp_type === 'add_remove_tag_into_msg') {
                let attachment = favoriteFiles.map((f) =>
                    f.id === change_file_data.file_id || change_file_data.file_id === change_file_data.conversation_id ?
                        {
                            ...f,
                            tag_list: f.tag_list ? [...f.tag_list.filter((t) => change_file_data.removetag.indexOf(t) === -1), ...change_file_data.newtag.filter(t => f.tag_list.indexOf(t) === -1)] : [...change_file_data.newtag],
                            tag_list_details: (f.tag_list_details && f.tag_list) ? [...f.tag_list_details.filter((t) => change_file_data.removetag.indexOf(t.tag_id) === -1), ...change_file_data.newtag_tag_data.filter(t => f.tag_list.indexOf(t.tag_id) === -1)] : [...change_file_data.newtag_tag_data],
                        } : f
                )
                setFavoriteFiles(attachment)
            } else if (change_file_data.xmpp_type === 'file_share_link_create') {
                setFavoriteFiles(prev => prev.map(f => f.id === change_file_data.id ? { ...f, url_short_id: change_file_data.url_short_id } : f))
            }

            setPopup({ key: 'change_file_data', value: null })
        }
    }, [change_file_data])


    useEffect(() => {
        let isMounted = true;

        const fetchData = () => {
            if (!active_conversation?.conversation_id) return;

            setFlagAndFileLoader(true);

            if (flagTab === 'messages' && isFlaggedOpen && !isFavoriteFileOpen) {
                setLoader(true);
                getFlaggedMsg({
                    variables: {
                        conversation_id: active_conversation.conversation_id,
                        page: 1,
                    },
                });
            } else if (flagTab === 'tasks' && isFlaggedOpen && !isFavoriteFileOpen) {
                setLoader(true);
                getFlaggedTask({
                    variables: {
                        conversation_id: active_conversation.conversation_id,
                        limit: 20,
                        page: 1,
                    },
                });
            } else if (isFavoriteFileOpen) {
                setLoader(true);
                getStarFiles({
                    variables: {
                        conversation_id: active_conversation.conversation_id,
                        page: 1,
                    },
                });
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [active_conversation, flagTab, pathname, isFavoriteFileOpen, getFlaggedMsg, getFlaggedTask, getStarFiles]);


    const [getNotifications] = useLazyQuery(Get_notifications_dashboard, {
        fetchPolicy: 'no-cache',
        variables: { page: 1 },
        onCompleted: (data) => {
            console.log("🚀 ~ DashboardProvider ~ Get_notifications_dashboard:", data)
            if (data.get_notifications_dashboard.pagination.page === 1) {
                setNotifications(data.get_notifications_dashboard)
            } else {
                setNotifications(prev => ({
                    ...prev,
                    notification: [...prev.notification, ...data.get_notifications_dashboard.notification],
                    pagination: data.get_notifications_dashboard.pagination,
                    summary: data.get_notifications_dashboard.summary
                }))
            }
            setPrevLoader(false);
            setNotificationsDone(true);
            setLoader(false);
        },
        onError: (err) => {
            console.error('Get_notifications_dashboard error', err);
            setNotificationsDone(true);
            setPrevLoader(false);
        }
    });


    useEffect(() => {
        // guard: only run when there is a real dashboardNotification
        if (!dashboardNotification) return;
        if (!['File', 'Task'].includes(dashboardNotification.type)) return;

        console.log(dashboardNotification);

        // avoid inserting the function itself into state (previous code mistakenly used the function name)
        // also avoid duplicates by checking existing ids
        setNotifications(prev => {
            const existing = Array.isArray(prev.notification) ? prev.notification : [];
            const alreadyExists = existing.some(n => n._id === dashboardNotification._id);
            if (alreadyExists) return prev;
            return {
                notification: [dashboardNotification, ...existing],
                pagination: { ...prev.pagination, total: prev.pagination.total + 1 },
                summary: prev.summary
            };
        });

        // clear the notification in redux once consumed
        dispatch(set_dashboardNotification(null)); // reset after use

        // include user?.id and dispatch in dependencies to avoid stale closure issues
    }, [dashboardNotification, user?.id, dispatch]);

    const [getFiles] = useLazyQuery(Get_file_dashboard, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            console.log("🚀 ~ DashboardProvider ~ Get_file_dashboard:", data)
            if (data.get_file_dashboard.pagination.page === 1) {
                setFiles(data.get_file_dashboard)
            } else {
                setFiles(prev => ({
                    ...prev,
                    files: [...prev.files, ...data.get_file_dashboard.files],
                    pagination: data.get_file_dashboard.pagination,
                    summary: data.get_file_dashboard.summary
                }))
            }
            setPrevLoader(false)
            setFilesDone(true);
            setLoader(false);
        }
        ,
        onError: (err) => {
            console.error('Get_file_dashboard error', err);
            setFilesDone(true);
            setPrevLoader(false);
        }
    });

    // ensure loader is turned off once all four API calls have completed (or errored)
    useEffect(() => {
        if (notificationsDone && filesDone) {
            console.log('All Loading Done...');

            setLoader(false);
        }
    }, [notificationsDone, filesDone]);

    useEffect(() => {
        setLoader(true)
        getNotifications({ variables: { page: 1 } });
        getFiles({ variables: { page: 1 } })
    }, [getNotifications, getFiles])

    return (
        <DashboardContext.Provider value={{ user, total_unread, conversations, files, setFiles, getFiles, tasks, categorizeTasks, flagged, setFlagged, notifications, setNotifications, prevloader, setPrevLoader, getNotifications, fileViewPopup, setFileViewPopup, loader, setLoader, totalFlaggedItems, activeRoomId, setActiveRoomId, flagTab, setFlagTab, flagAndFileLoader, isFavoriteFileOpen, setIsFavoriteFileOpen, favoriteFiles, flaggedTasks, isFlaggedOpen, setIsFlaggedOpen, getStarFiles, getFlaggedTask, getFlaggedMsg, pagination, msgContainerRef, prevScrollHeightMsg }}>
            {children}
        </DashboardContext.Provider>
    );
};


export const useDashboard = () => {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error("useDashboard must be used within a DashboardProvider");
    }
    return context;
}